var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgComments = function SvgComments(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 12,
    fill: "#EBFAF3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_53183)",
    filter: "url(#filter0_d_468_53183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 11.5996C16.3832 11.5996 11 16.4444 11 22.3996C11 24.4812 11.6584 26.4976 12.9072 28.2412C12.6708 30.856 12.0372 32.7972 11.1172 33.7168C10.9956 33.8384 10.9652 34.0244 11.042 34.178C11.11 34.3152 11.25 34.3996 11.4 34.3996C11.4184 34.3996 11.4368 34.3984 11.4556 34.3956C11.6176 34.3728 15.3808 33.8312 18.1028 32.26C19.6484 32.8836 21.2948 33.1996 23 33.1996C29.6168 33.1996 35 28.3548 35 22.3996C35 16.4444 29.6168 11.5996 23 11.5996ZM17.4 23.9996C16.5176 23.9996 15.8 23.282 15.8 22.3996C15.8 21.5172 16.5176 20.7996 17.4 20.7996C18.2824 20.7996 19 21.5172 19 22.3996C19 23.282 18.2824 23.9996 17.4 23.9996ZM23 23.9996C22.1176 23.9996 21.4 23.282 21.4 22.3996C21.4 21.5172 22.1176 20.7996 23 20.7996C23.8824 20.7996 24.6 21.5172 24.6 22.3996C24.6 23.282 23.8824 23.9996 23 23.9996ZM28.6 23.9996C27.7176 23.9996 27 23.282 27 22.3996C27 21.5172 27.7176 20.7996 28.6 20.7996C29.4824 20.7996 30.2 21.5172 30.2 22.3996C30.2 23.282 29.4824 23.9996 28.6 23.9996Z",
    fill: "#83C972"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_468_53183",
    x: 5,
    y: 7,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230208 0 0 0 0 0.65 0 0 0 0 0.420303 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_468_53183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_468_53183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_53183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11 11)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgComments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/comments.59d6dee7e198368b29c723c5ab987b1f.svg";